<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="ExpensesGroupDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" flat class="mt-3 mb-3 body-2 primary">{{button}}</v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon dark @click="ExpensesGroupDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
          <v-toolbar-title>Cadastro de planos de contas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn dark flat @click="dialog = false">Salvar</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <h2
          class="title mx-4 mt-4 mb-1 text-xs-left"
          style="font-weight:400;"
        >Lista de planos de contas</h2>
        <div
          class="caption text-xs-left px-4"
        >Cadastre seus planos de contas fazendo vínculo com os planos do sistema</div>
        <RegisterAccountPlans :reloadUserAccountPlans="getAccountPlans" />
        <v-flex xs4 px-5 ml-1>
          <v-select
            class="iptSearchUserAccPlan"
            v-model="condominium_id"
            :items="condominiums"
            append-icon="search"
            @click:append="getAccountPlans(condominium_id)"
            item-text="name_fantasy"
            item-value="id"
            label="Selecione o condomínio"
          ></v-select>
        </v-flex>
        <AccountPlanList :userAccountsList="userAccountsPlan" :getAccountPlans="getAccountPlans" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import AccountPlanList from "./AccountPlanList";
import RegisterAccountPlans from "./RegisterAccountPlans";
export default {
  components: {
    AccountPlanList,
    RegisterAccountPlans
  },
  props: {
    button: String
  },
  data() {
    return {
      condominiums: [],
      condominium_id: "",
      userAccountsPlan: [],
      ExpensesGroupDialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  mounted() {
    this.getComdominiums();
  },
  methods: {
    validSearch() {
      let fieldError = document.querySelector(".iptSearchUserAccPlan label");
      fieldError.classList.add("primary--text");
      setTimeout(function() {
        fieldError.classList.remove("primary--text");
      }, 2000);
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.condominiums = response.data;
      });
    },
    getAccountPlans() {
      let dataSearch = {};
      dataSearch.params = { condominium_id: this.condominium_id };

      if (!this.condominium_id) {
        this.validSearch();
        return;
      }

      let query = { condominium_id: this.condominium_id };

      let obj = {
        url: "/api/planAccount",
        query: dataSearch,
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.userAccountsPlan = response.data.map(item => {
          item.condominium_id = this.condominium_id;
          return item;
        });
      });
    }
  }
};
</script>